import React from 'react';
import {useTranslation} from 'react-i18next';
import {useReservation} from 'context/reservation';

function ReservationNumberBox() {
  const {t} = useTranslation();
  const {data: reservation} = useReservation();
  const reservationNumber = reservation?.booking_reference;

  if (!reservationNumber) {
    return null;
  }

  return (
    <div className="px-4 py-2 rounded-lg absolute top-0 rounded-none left-0 w-full laptop-ml:bottom-0 laptop-ml:top-auto text-[var(--font-primary)] bg-[var(--background-main)]">
      <div className="text-sm ">
        {t('reservation_number')}: {reservationNumber}
      </div>
    </div>
  );
}

export {ReservationNumberBox};
